import { useState } from "react";
import { Row, Col, Drawer, Dropdown, Menu } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";

import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu as MenuStyled,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
        });
      }
      setVisibility(false);
    };

    const servicesMenu = (
      <Menu>
        <Menu.Item key="mission" onClick={() => scrollTo("mission")}>
          Process Automation
        </Menu.Item>
        <Menu.Item key="network" onClick={() => scrollTo("network")}>
          Network Installations & Setup
        </Menu.Item>
        <Menu.Item key="about" onClick={() => scrollTo("about")}>
          Mobile App Development
        </Menu.Item>
      </Menu>
    );

    return (
      <>
        <Dropdown overlay={servicesMenu} trigger={['hover']}>
          <CustomNavLinkSmall>
            <Span style={{ cursor: 'pointer' }}>{t("Services")}</Span>
          </CustomNavLinkSmall>
        </Dropdown>
        <CustomNavLinkSmall
          style={{ width: "180px" }}
          onClick={() => scrollTo("contact")}
        >
          <Span>
            <Button>{t("Contact")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <img src="/company_logo_navbar.png" alt="Logo" width="150" height="48" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <MenuStyled>Menu</MenuStyled>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
